export default
    [
        {
            step: "details",
            path: "/buildings/:buildingId/details", 
            dataPath: "details",
            start: true
        },
        {
            step: "details",
            path: "/buildings/:buildingId/details/contacts",
            dataPath: "contacts"
        },
        {
            step: "details",
            path: "/buildings/:buildingId/details/address", 
            dataPath: "address"
        },
        {
            step: "details",
            path: "/buildings/:buildingId/details/location", 
            dataPath: "location"
        },
        {
            step: "details",
            path: "/buildings/:buildingId/details/serviceCharge", 
            dataPath: "serviceCharge"
        },
        {
            step: "amenities",
            path: "/buildings/:buildingId/amenities",
            dataPath: "amenities"
        },
        {
            step: "amenities",
            path: "/buildings/:buildingId/amenities/info", 
            dataPath: "amenities"
        },
        {
            step: "amenities",
            path: "/buildings/:buildingId/amenities/visitorProcess",
            dataPath: "visitorProcess"
        },
        {
            step: "files",
            path: "/buildings/:buildingId/files", 
            dataPath: "files"
        },
        {
            step: "files",
            path: "/buildings/:buildingId/files/organise",
            dataPath: "files"
        },
        {
            step: "tenants",
            path: "/buildings/:buildingId/tenants",
            dataPath: "tenants"
        },
        {
            step: "tenants",
            path: "/buildings/:buildingId/tenants/info",
            dataPath: "tenants"
        },
        {
            step: "complete",
            path: "/buildings/:buildingId/complete",
            dataPath: "complete",
            end: true
        }
    ];